export function clampMediaIndex(index, length) {
  if (!length || length < 1) {
    return 0;
  }

  const numericIndex = typeof index === 'number' && !Number.isNaN(index) ? index : 0;
  return Math.min(Math.max(0, numericIndex), length - 1);
}
